import { render } from "./DelModal.vue?vue&type=template&id=fe440a3e"
import script from "./DelModal.vue?vue&type=script&lang=js"
export * from "./DelModal.vue?vue&type=script&lang=js"
script.render = render

export default script